export const exerciseOptions = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': 'eec3fc4475msh8e6cdba9ba8be54p174d02jsn70e5da808a55',
      'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
    }
  };

  export const youtubeOptions = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': 'eec3fc4475msh8e6cdba9ba8be54p174d02jsn70e5da808a55',
      'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
    }
  };

export const fetchData = async (url,options) =>{
    const response = await fetch(url,options);
    const data = await response.json();

    return data;
}